import { useScrollbarInteraction } from './useScrollbarInteraction';

export const ScrollbarInteractionManager = () => {
  useScrollbarInteraction();

  return null;
};
